// Pure pathname predicates driving the authenticated layout (pages/Home.tsx):
// which routes force-collapse the sidebar and which render full-bleed.

export const isEditorRoute = (pathname: string): boolean =>
  (/^\/web-leads\/[^/]+/.test(pathname) && !/^\/web-leads\/(folder\/|create(\/|$))/.test(pathname)) ||
  (/^\/journeys\/[^/]+/.test(pathname) && !/^\/journeys\/(folders\/|create(\/|$))/.test(pathname));

// Presentations iframe routes where the embedded wizard/builder needs the full
// viewport (ENG-979). Child-app paths are mirrored into the portal URL by
// SsoIframeShell route sync, so plain pathname matching works.
export const isPresentationsWizardRoute = (pathname: string): boolean =>
  /^\/presentations\/my-presentations\/welcome(\/|$)/.test(pathname) ||
  /^\/presentations\/templates\/new(\/|$)/.test(pathname) ||
  /^\/presentations\/templates\/[^/]+\/(edit|slides)(\/|$)/.test(pathname);

// Routes whose content spans the full viewport with no surrounding padding
// (e.g. embedded iframe shells). Kept separate from the collapse predicates
// above so sidebar-collapse stays limited to editor and wizard/builder routes
// while list pages inside /presentations still render full-bleed.
export const isFullBleedRoute = (pathname: string): boolean =>
  isEditorRoute(pathname) ||
  /^\/presentations(\/|$)/.test(pathname) ||
  /^\/mia\/canonry-dashboard(\/|$)/.test(pathname);
